import {Injectable} from '@angular/core';
import {Service} from '../../common/service.class';
import {OtherEducation} from './other-education.model';
import {UserModelListService} from '../../common/user-model-list.service';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
@Injectable()
export class OtherEducationService extends UserModelListService<OtherEducation> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'otherEducation', OtherEducation);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/education/other/other-education.service.ts